// Angular
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
// Object-Path
import * as objectPath from 'object-path';
// Layout
import { LayoutConfigService, SplashScreenService } from '../../../../core/_base/layout';

@Component({
	selector: 'kt-splash-screen',
	templateUrl: './splash-screen.component.html',
	styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {
	// Public proprties
	loaderLogo: string;
	loaderType: string;
	loaderMessage: string;

	@ViewChild('splashScreen', {static: true}) splashScreen: ElementRef;
	@Input() splashScreenData:any;
	@Input() flag:boolean = false;
	/**
	 * Component constructor
	 *
	 * @param el: ElementRef
	 * @param layoutConfigService: LayoutConfigService
	 * @param splashScreenService: SplachScreenService
	 */
	constructor(
		private el: ElementRef,
		private layoutConfigService: LayoutConfigService,
		private splashScreenService: SplashScreenService) {
	}
	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.flag = this.flag ? true : false;
		// init splash screen, see loader option in layout.config.ts
			const loaderConfig = this.layoutConfigService.getConfig('loader');
			this.loaderType = objectPath.get(loaderConfig, 'type');
			this.loaderLogo = objectPath.get(loaderConfig, 'logo');

		 if(localStorage.getItem('loadingLogo')){
			this.loaderLogo = localStorage.getItem('loadingLogo')
     	}
		this.loaderMessage = objectPath.get(loaderConfig, 'message');
		// this.loaderMessage = "testingg message";

		this.splashScreenService.init(this.splashScreen);

	}
	ngOnChanges(){
		this.flag = this.flag ? true : false;
	}
	ngAfterViewInit(){
		this.flag = this.flag ? true : false;
	}
}
